<template>
    <span>
        <device-health-icon
            v-if="computedName === 'showHealthIcon'"
            :value="
                getHealthStatusValue(rowData, fieldName, statusDateFieldName)
            "
        >
        </device-health-icon>
        <v-icon
            v-if="
                computedName === 'showCheckboxIcon' &&
                    rowData[fieldName] === true
            "
        >
            {{ icons.check }}
        </v-icon>
        <span v-if="fieldType === 'short'">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <span v-on="on">
                        {{ resolvedCustomField.short }}
                    </span>
                </template>
                <span class="text-caption">
                    {{ resolvedCustomField.full }}
                </span>
            </v-tooltip>
        </span>
        <span v-if="fieldType === 'other'">
            {{ resolvedCustomField }}
        </span>
    </span>
</template>

<script>
// This component will render different component based on the field computedName
// the component can be an icon or a text or a link...
// if computedName: formatTags ===> { short: '...', full: '....' }
import DeviceHealthIcon from '@/components/Fields/DeviceHealthIcon';
import { isEmpty } from '@/common/helpers';
import { get } from 'lodash';

export default {
    name: 'DataTableCustomField',
    components: {
        'device-health-icon': DeviceHealthIcon
    },
    props: {
        fieldName: {
            type: String,
            required: true
        },
        computedName: {
            type: String,
            required: true
        },
        computedParams: {
            type: Object,
            required: false,
            default: () => {}
        },
        rowData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            statusDateFieldName: 'healthCheckStatusDate'
        };
    },
    computed: {
        resolvedCustomField() {
            if (!isEmpty(this.computedName) && !isEmpty(this.fieldName)) {
                const fn = this[this.computedName];
                if (fn) {
                    return fn(
                        get(this.rowData, this.fieldName),
                        this.computedParams
                    );
                } else {
                    return `**${this.computedName}**`;
                }
            }
            return get(this.rowData, this.fieldName);
        },
        fieldType() {
            if (this.computedName === 'showHealthIcon') {
                return 'icon';
            } else if (this.computedName === 'showCheckboxIcon') {
                return 'icon';
            } else if (this.resolvedCustomField.short) {
                return 'short';
            } else {
                return 'other';
            }
        }
    },
    methods: {
        // ================ Custom filter functions =================
        formatTags(value) {
            if (value) {
                const tags = value
                    .map(item => {
                        return item.name;
                    })
                    .join(', ');
                return this.shortenValue(tags, 20);
            }
            return '';
        },
        localeDateTime(value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleString();
            }
            return '';
        },
        localeDate(value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleDateString();
            }
            return '';
        },
        localeTime(value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleTimeString();
            }
            return '';
        },
        shortenValue(value, maxLength = 20) {
            if (typeof value === 'string') {
                return {
                    short:
                        value.length > maxLength
                            ? value.slice(0, maxLength) + '...'
                            : value,
                    full: value
                };
            } else {
                return '';
            }
        },
        eventStatusShorten(value) {
            return this.shortenValue(value, 25);
        },
        getHealthStatusValue(item, statusField, statusDateField) {
            return {
                status: item[statusField] || '',
                statusDate: item[statusDateField] || ''
            };
        }
    }
};
</script>
